import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { action } from 'satcheljs/lib/legacy';
import { getSurfaceStore } from '../store/surfaceStore';

import assign from 'object-assign';

export default action('updateCalendarEvent')(function updateCalendarEvent(
    calendarEvent: CalendarEvent
) {
    const surfaceStore = getSurfaceStore();

    const [surfaceItem] = surfaceStore.calendarItems.filter(
        item => item.ItemId.Id === calendarEvent.ItemId.Id
    );

    if (surfaceItem) {
        assign(surfaceItem, calendarEvent);
    }
});
